import React from "react";
import Step from "@components/Stepper/Step/index";

//Types
import { IStepperProps } from "./interface";

import { Container } from "./styles";
const Stepper = (props: IStepperProps) => {
  return (
    <div className={props.className}>
      <Container>
        {props.steps.map((step, index: number, list) => {
          const { currentStep } = props;
          if (index === currentStep && props.isRejected) {
            return <Step indicator={step} active={"#f49090"} key={index} />;
          }
          return index <= currentStep ? (
            <Step indicator={step} active={"#90D1F4"} key={index} />
          ) : (
            <Step indicator={step} active={"#D8DDE1"} key={index} />
          );
        })}
      </Container>
    </div>
  );
};

export default Stepper;
